import { idForPath, restDelete, restGet, restPatch, restPost, restPut } from "./restClient.js";

const ROOT = "/v1/langsmith-integrations";

export function listLangSmithIntegrations({ signal } = {}) {
    return restGet(ROOT, null, { signal });
}

export function createLangSmithIntegration({ apiKey, workspaceId }) {
    return restPost(ROOT, { api_key: apiKey, workspace_id: workspaceId });
}

export function replaceLangSmithKey(integrationId, apiKey) {
    return restPatch(`${ROOT}/${idForPath(integrationId)}`, { api_key: apiKey });
}

export function listLangSmithProjects(integrationId, { signal } = {}) {
    return restGet(`${ROOT}/${idForPath(integrationId)}/projects`, null, { signal });
}

export function setLangSmithWatchedProjects(integrationId, projectIds) {
    return restPut(`${ROOT}/${idForPath(integrationId)}/projects`, {
        project_ids: projectIds,
    });
}

export function deleteLangSmithIntegration(integrationId) {
    return restDelete(`${ROOT}/${idForPath(integrationId)}`);
}
